// removed by extract-text-webpack-plugin
module.exports = {"chipsPopupModalContainer":"_1TTRAyQApbuROWIps8T_Et","chipsPopupModal":"_1EtA3w3Qse-pH4gvPqDMwP","chipIconContainer":"_2UpjsKRRteqZ4dJ2TwLqM7","chipIcon":"MOQlJHxpMpYe908f_5o5Z","chipValueOuter":"_1zeLqdJsVWc9Xl7gQC7-xL","chipValueInner":"_2cGthmyArhQk77R2Hg_VuR"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/simplified/mobile/css/chipsModal.css
// module id = 1028
// module chunks = 0